<h1 mat-dialog-title>Do you want to delete this file?</h1>

<div mat-dialog-content>

  <p>
    {{data}}
  </p>

</div>

<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-button
    style="margin-right: 9px;"
    (click)="onClickNo()">
    NO
  </button>
  <button mat-raised-button
    color="primary"
    (click)="onClickYes()">
    YES
  </button>
</div>